import { useState, useEffect, useCallback } from 'react';

export interface Notification {
  id: string;
  templateCode: string;
  subject: string;
  body: string;
  status: 'SENT' | 'READ' | 'DISMISSED';
  priority: 'LOW' | 'NORMAL' | 'HIGH' | 'URGENT';
  createdAt: string;
}

const POLL_INTERVAL = 30_000; // 30 seconds

export function useNotifications() {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchNotifications = useCallback(async () => {
    try {
      // TODO: Replace with real API call: GET /api/v1/notifications?status=SENT,READ&pageSize=20
      // For now, mock data
      setNotifications([
        { id: '1', templateCode: 'CREDENTIAL_EXPIRY_7DAY', subject: 'URGENT: Graph secret expires in 7 days', body: 'Acme Corp tenant secret expires 2026-04-17.', status: 'SENT', priority: 'HIGH', createdAt: '2026-04-10T08:00:00+10:00' },
        { id: '2', templateCode: 'ONBOARDING_COMPLETED', subject: 'Onboarding Complete: Contoso Ltd', body: 'Contoso Ltd is now ACTIVE.', status: 'SENT', priority: 'NORMAL', createdAt: '2026-04-09T15:30:00+10:00' },
        { id: '3', templateCode: 'RECONCILIATION_CRITICAL', subject: 'Critical discrepancies found: Fabrikam', body: '3 untracked licenses detected.', status: 'READ', priority: 'HIGH', createdAt: '2026-04-09T07:15:00+10:00' },
      ]);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [fetchNotifications]);

  const unreadCount = notifications.filter(n => n.status === 'SENT').length;

  const markAsRead = useCallback(async (id: string) => {
    // TODO: POST /api/v1/notifications/{id}/read
    setNotifications(prev => prev.map(n => n.id === id ? { ...n, status: 'READ' } : n));
  }, []);

  const markAllRead = useCallback(async () => {
    // TODO: POST /api/v1/notifications/mark-all-read
    setNotifications(prev => prev.map(n => n.status === 'SENT' ? { ...n, status: 'READ' } : n));
  }, []);

  const dismiss = useCallback(async (id: string) => {
    // TODO: POST /api/v1/notifications/{id}/dismiss
    setNotifications(prev => prev.filter(n => n.id !== id));
  }, []);

  return { notifications, unreadCount, loading, markAsRead, markAllRead, dismiss, refresh: fetchNotifications };
}
